import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import NavBar from "../../Nav Bar/NavBar";
import VipCard from "../../components/vip card/VipCard";
import VipUpgrade from "../../components/vip upgrade/VipUpgrade";
import Question from "../../components/faq/Questions";
import ColoredLogo from "../../assets/ColoredLogo.svg";
import SEO from "../../components/seo/seo";
import "./vip.css";

const Vip = () => {
  useEffect(() => {
    AOS.init({ duration: 1500, once: true });
  }, []);
  return (
    <div>
       <SEO
        title="GiftCard8 VIP | Exclusive Rewards & Benefits"
        description="Join GiftCard8's VIP program and enjoy exclusive rewards, faster transactions, and special bonuses. Unlock 11 VIP levels with amazing perks!"
        keywords="GiftCard8 VIP, VIP gift card trading, exclusive rewards, best gift card rates, premium benefits"
        image="../../assets/ColoredLogo.svg"
        url="https://giftcard8.com/vip-upgrades"
      />
      <NavBar linkColor="#000" logo={ColoredLogo} bg="#fff" />
      <div className="vipContainer" data-aos="fade-up">
        <h3 className="vipHeader">
          No waiting!
          <br />
          Become GiftCard8's Top VIP now! 👑
        </h3>
        <p className="vipText">
          Our VIP system consists of 11 levels, defined by experience points.
          <br />
          The higher your VIP level, the more benefits you enjoy, including:
        </p>
      </div>
      <VipCard />
      <VipUpgrade />
      <Question />
    </div>
  );
};

export default Vip;
